import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { startChecking } from '../actions/auth'

export const AdminRoute = ({ children }) => {
    
const { acces } = useSelector(state => state.auth)
const dispatch = useDispatch()

useEffect(() => {
        
 
    dispatch( startChecking() )

}, [dispatch])

    return (
        (acces === "admin")
        ?   children  
        :  <Navigate to="/" />
    )              
}